import React from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const features = ["Laminat und Parkett", "PVC-Beläge und Linoleum", "Estrich und Holzböden", "OSB-Platten und Terrassen"];
export default function FlooringServicesGrid() {
  return <section id="services-grid-bodenlegerarbeiten" className="py-12 md:py-16 bg-background">
      <div className="page-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {}
          <div className="relative w-full aspect-[4/3] lg:aspect-[5/4] rounded-2xl overflow-hidden shadow-md">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/flooring_service_room.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/flooring_service_room.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/flooring_service_room.png-wvc-sizes" alt="Professionelle Bodenlegerarbeiten in einem hellen Raum" className="object-cover w-full h-full" loading="lazy" />
          </div>

          {}
          <div className="flex flex-col gap-8">
            <div className="space-y-4">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground tracking-tight">
                Bodenlegerarbeiten
              </h2>
              <p className="text-lg text-muted-foreground leading-relaxed max-w-xl">
                Professionelle Bodenverlegung für jeden Anspruch. Ob Laminat, Parkett oder
                PVC – wir sorgen für den perfekten Boden.
              </p>
            </div>

            <ul className="flex flex-col gap-3.5">
              {features.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <Check className="size-5 text-primary shrink-0 mt-0.5" strokeWidth={2} />
                  <span className="text-foreground text-base">{feature}</span>
                </li>)}
            </ul>

            <div className="pt-2">
              <Button asChild size="lg" className="rounded-lg w-fit text-base px-8">
                <Link to="/ContactPage">Angebot anfordern</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}